import { Component, Inject, OnDestroy } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';
import { AccountDeleteConfirmationType } from '@ridango/core/lib/enums/features.enum';
import { Subject } from 'rxjs';
import { ModalController } from '@ionic/angular';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-customer-account-delete-dialog',
    templateUrl: 'customer-account-delete-dialog.component.html',
    styleUrls: ['./customer-account-delete-dialog.component.scss']
})
export class CustomerAccountDeleteDialogComponent implements OnDestroy {
    private readonly componentDestroyed$ = new Subject<void>();
    accountDeleteConfirmationType = AccountDeleteConfirmationType;
    accountDeletionConfirmed = false;
    isContrast$ = this.applicationFacade.highContrast$;

    constructor(
        private readonly modalCtrl: ModalController,
        @Inject('ENV') public env: Env,
        private readonly applicationFacade: ApplicationFacade
    ) {}

    toggleDeleteConfirmCheckbox() {
        this.accountDeletionConfirmed = !this.accountDeletionConfirmed;
    }

    confirmDelete() {
        this.modalCtrl.dismiss(true, 'confirm');
    }

    cancelDelete() {
        this.modalCtrl.dismiss(null, 'cancel');
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
